module.exports = __webpack_public_path__ + "img/building13.b77d8006.jpg";